import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadDocumentsS3Service {
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient) {}

  pushFile(url: string, file: File): Observable<any> {
    return this.http.put<any>(url, file, {
      ...this.httpOptions,
      observe: 'response'
    });
  }

  pushFilePresigned(url: string, file: File): Observable<any> {
    this.httpOptions.headers = new HttpHeaders({
      'Content-Type': file.type
    });
    return this.http.put<any>(url, file, {
      ...this.httpOptions,
      observe: 'response'
    });
  }
}
